module.exports = __webpack_public_path__ + "assets/img/simply-Brand_04.4083a56c.png";